function getHeaders(headersAdditive, auth, contentType) {
    const headers = {
        'Content-Type': contentType
    }
    if(auth) {
        var authHeader = {
            "Authorization": "Bearer "+localStorage.getItem("tokenAuth")
        }
    }
    return Object.assign(headers, headersAdditive, authHeader);
}

export default getHeaders;